import { greys, ultraViolets, reds } from '../colors/index.js';
var style = {
  100: "1px solid",
  200: "2px solid"
};
// BASE TOKENS
var normal = {
  100: style[100] + " " + greys[20],
  200: style[200] + " " + greys[20]
};
var disabled = {
  100: style[100] + " " + greys[20],
  200: style[200] + " " + greys[20]
};
var active = {
  100: style[100] + " " + ultraViolets[30],
  200: style[200] + " " + ultraViolets[30]
};
var hover = {
  100: style[100] + " " + greys[30],
  200: style[200] + " " + greys[30]
};
var error = {
  100: style[100] + " " + reds[50],
  200: style[200] + " " + reds[50]
};
var focused = {
  100: style[100] + " " + ultraViolets[70],
  200: style[200] + " " + ultraViolets[70]
};
var selected = {
  100: style[100] + " " + ultraViolets[70],
  200: style[200] + " " + ultraViolets[70]
};
// CONTEXTUAL TOKENS
var input = {
  normal: normal[100],
  disabled: disabled[100],
  focused: focused[100],
  hover: hover[100],
  error: error[100]
};
var card = {
  normal: normal[100],
  hover: hover[100],
  focused: focused[100],
  active: active[100],
  selected: selected[100]
};
var dropdown = {
  normal: normal[100]
};
var table = {
  row: normal[100]
};
var checkbox = {
  normal: style[200] + " " + greys[40],
  disabled: style[200] + " " + greys[40],
  hover: style[200] + " " + ultraViolets[70],
  focused: focused[200],
  error: error[200]
};
var radio = {
  normal: style[200] + " " + greys[40],
  disabled: style[200] + " " + greys[40],
  hover: style[200] + " " + ultraViolets[70],
  focused: focused[200],
  selected: selected[200]
};
export { active, card, checkbox, disabled, dropdown, error, focused, hover, input, normal, radio, selected, table };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
